module.exports = __webpack_public_path__ + "static/img/home_bg_peitaochanye.5e9e5ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/home_bg_peitaochanye.png
// module id = YNLb
// module chunks = 1